module.exports = __webpack_public_path__ + "img/file-manageer.e5f14bed.svg";